import {Component, computed, input, model} from '@angular/core';
import {IACKATHON_STEP, IACKATHON_STEP_LABEL_KEY} from '../../models/iackathon_steps';
import {isIackathonStepCompleted, isIackathonStepLocked} from '../../models/iackathon-step-progress';
import {IackathonSave} from '../../services/iackathon-saves.service';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-iackathon-progress-viewer',
    imports: [
        MatIconModule,
        TranslateModule
    ],
    templateUrl: './iackathon-progress-viewer.component.html',
})
export class IackathonProgressViewerComponent {
    save = input.required<IackathonSave>();
    activeState = model.required<IACKATHON_STEP>();

    private state = computed(() => this.save()?.attributes.content.state);

    protected readonly steps: ReadonlyArray<{ id: IACKATHON_STEP; labelKey: string }> = (
        Object.entries(IACKATHON_STEP_LABEL_KEY) as Array<[IACKATHON_STEP, string]>
    ).map(([id, labelKey]) => ({id, labelKey}));

    protected isStepCompleted(step: IACKATHON_STEP): boolean {
        return isIackathonStepCompleted(this.state(), step);
    }

    protected isStepLocked(step: IACKATHON_STEP): boolean {
        return isIackathonStepLocked(this.state(), step);
    }

    protected onStepClick(step: IACKATHON_STEP): void {
        this.activeState.set(step);
    }
}
